jQuery(document).ready(function($) {

    setupStepper();

    function setupStepper() {
        if ($('.gk_stepper').length) {
            var stepper = $('.gk_stepper');
            var loggedin = stepper.data("loggedin");
            if (loggedin != '1') {
                var guide_id = stepper.data("stepper");
                var cookie = Cookies.get("guide" + guide_id);
                if (cookie) {
                    var completed_steps = cookie.split('-');
                    var i = 1;
                    $(stepper).children('li').each(function () {
                        if ($.inArray(i.toString(), completed_steps) != -1) {
                            $(this).addClass('completed');
                            $(this).find('.circle').html('<i class="material-icons">&#xE876;</i>');
                            $(this).find('.stepper-check').removeClass('btn-success').addClass('btn-danger').text('Ej klar');
                            $(this).find('.stepper-check').attr("data-completed", 1);
                        }
                        i++;
                    });
                    if (stepper.children('li').length == stepper.children('li.completed').length) {
                        stepper.closest('.et_pb_stepper_module').find('.stepper-completedinfo').removeClass('hidden');
                        $(stepper).children('li').each(function () {
                            $(this).removeClass('active');
                        });
                    }
                }
                var activestep = Cookies.get("guide" + guide_id + "_active");
                if (activestep)
                {
                    if (activestep) {
                        $(stepper).children('li').first().removeClass('active');
                        $(stepper).children('li').eq(activestep).addClass('active');
                    }
                }
            }
        }
    }

    $('.stepper-button').click(function (e) {
        e.preventDefault();
        var guide_step = $(this).data("next");
        stepper_step($(this), guide_step);
    });

    function stepper_step(stepper, guide_step) {
        var step = stepper.closest('li').prev('li');
        if (guide_step == 1) {
            step = stepper.closest('li').next('li');
        }
        if (step.length) {
            stepper.closest('li').removeClass('active');
            step.addClass('active');
            var guide_id = stepper.closest('.gk_stepper').data("stepper");
            if (step.index() > 0) {
                Cookies.set("guide" + guide_id + "_active", step.index());
            }
            if ($(document).scrollTop() > $(step).offset().top) {
                $('html, body').animate({
                    scrollTop: $(step).offset().top - 100
                }, 400);
            }
        }
    }

    $('.stepper-check').click(function (e) {
        e.preventDefault();
        var guide_step = $(this).data("step");
        var guide_completed = $(this).attr("data-completed");
        var guide_id = $(this).closest('.gk_stepper').data("stepper");
        var loggedin = $(this).closest('.gk_stepper').data("loggedin");

        var data = {
            'action': 'stepper_step',
            'guide_step': guide_step,
            'guide_id': guide_id,
            'guide_completed': guide_completed
        };
        if (guide_completed == 1) {
            $(this).closest('li').removeClass('completed');
            $(this).closest('li').find('.circle').text(guide_step);
            $(this).removeClass('btn-danger').addClass('btn-success').html('<i class=\"material-icons\">&#xE876;</i> Klar');
            $(this).attr("data-completed", 0);
        }
        else {
            $(this).closest('li').addClass('completed');
            $(this).closest('li').find('.circle').html('<i class="material-icons">&#xE876;</i>');
            $(this).removeClass('btn-success').addClass('btn-danger').text('Ej klar');
            $(this).attr("data-completed", 1);
            stepper_step($(this), 1);
        }

        var currentstepper = $(this).closest('ul');
        if (currentstepper.children('li').length == currentstepper.children('li.completed').length) {
            currentstepper.closest('.et_pb_stepper_module').find('.stepper-completedinfo').removeClass('hidden');
        }
        else {
            currentstepper.closest('.et_pb_stepper_module').find('.stepper-completedinfo').addClass('hidden');
        }

        if (loggedin == '1') {
            $.post('/wp-admin/admin-ajax.php', data, function (response) {
            });
        }
        else {
            setStepperCookie(guide_id, guide_step, guide_completed);
        }
    });

    function setStepperCookie(id, step, completed) {
        var cookiename = "guide" + id;
        var cookie = Cookies.get(cookiename);
        if (cookie) {
            if (completed == 0 && cookie.split('-').indexOf(step) == -1) {
                cookie = cookie + '-' + step;
            }
            else {
                cookie = removeValue(cookie, step, '-');
            }

            if (cookie.length > 0)
                Cookies.set(cookiename, cookie);
            else
                Cookies.remove(cookiename);
        }
        else if (completed == 0) {
            Cookies.set(cookiename, step);
        }
    }

    $('.stepper-reset').click(function (e) {
        e.preventDefault();
        var i = 0;
        $(this).parent().addClass('hidden');

        $(this).closest('.et_pb_stepper_module').find('ul').children().each(function () {
            i++;
            var check = $(this).find('.stepper-check');
            var guide_step = check.data("step");

            if (i == 1)
                $(this).addClass('active');
            else
                $(this).removeClass('active');
            $(this).removeClass('completed');
            $(this).find('.circle').text(guide_step);
            check.removeClass('btn-danger').addClass('btn-success').text('Klar');
            check.attr("data-completed", 0);
        });

        var guide_id = $(this).closest('.et_pb_stepper_module').find('.gk_stepper').data("stepper");
        var loggedin = $(this).closest('.et_pb_stepper_module').find('.gk_stepper').data("loggedin");

        if (loggedin == '1') {
            var data = {
                'action': 'stepper_reset',
                'guide_id': guide_id
            };
            $.post('/wp-admin/admin-ajax.php', data, function (response) {
            });
        }
        else {
            Cookies.remove("guide" + guide_id);
        }
    });

    $('.step').click(function (e) {
        e.preventDefault();
        $(this).closest('ul').children().each(function () {
            $(this).removeClass('active');
        });
        $(this).closest('li').addClass('active');
        var guide_id = $(this).closest('.gk_stepper').data("stepper");
        console.log(guide_id);
        Cookies.set("guide" + guide_id + "_active",$(this).closest('li').index());
    });
});